import React from "react";
import { createRoot } from 'react-dom/client';
import App from 'components/05-react/App';
import client from 'kineticGraphql/apollo-client';
import * as Queries from './queries.graphql';
import renderResults from './src/renderResults.jsx';

const root = document.getElementById('advocacy-listing-root');
const { facets, filters, title, resultQueryName, promotedId, sort, itemsPerPage, dateRange } = root.dataset;

async function fetchAd(id) {
  try {
    const res = await client.query({
      query: Queries.Advertisement,
      variables: {
        id: [ id ],
      },
    });
    return res.data.entityQuery.items[0];
  }
  catch(err) {
    console.error(err);
  }
}

(async () => {
  async function preprocessResults(results) {
    if (typeof promotedId === 'undefined') {
      return results;
    }
    // Fetch the ad.
    const ad = await fetchAd(promotedId);
    if (results.length > 0 && results.length < 6) {
      // Insert the promoted item at the end if there are less than 6 items.
      results.push(ad);
    } else {
      // Insert the promoted item at the 6th position.
      results.splice(5, 0, ad);
    }
    return results;
  }

  createRoot(root).render(<App
    viewFacets={facets ? JSON.parse(facets) : undefined}
    viewTitle={title}
    viewItemsPerPage={parseInt(itemsPerPage, 10)}
    viewFilters={JSON.parse(filters)}
    viewResultQuery={Queries[resultQueryName]}
    viewSort={JSON.parse(sort)}
    viewDateRange={dateRange ? JSON.parse(dateRange) : undefined}
    viewPreprocessResults={preprocessResults}
    viewRenderResults={renderResults}
    viewContainerClass="advocacy-listing-view"
  />);
})();
